import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { SEND_PASSWORD_RESET_EMAIL } from 'actionTypes';
import { isActionInProgress } from 'selectors';

import Form from 'Components/Form';

import { Modal, Text, Alert } from 'frontend-component-library';

export const RESET_KEY = 'reset';

class PasswordResetForm extends Component {
  handleSubmit = ({ email }) => {
    this.props.sendPasswordResetEmail(email);
  };

  render() {
    const { successAlert, closeModal, isFetching, errors } = this.props;
    return (
      <React.Fragment>
        <Modal.Header closeModal={closeModal}>
          <h2 className="">Reset Password</h2>
        </Modal.Header>
        <Modal.Section>
          <Alert type="success">{successAlert}</Alert>
          <Form
            onSubmit={this.handleSubmit}
            disabled={isFetching}
            submitText="Send password reset email"
            errors={errors}
            className="AuthForm"
          >
            <Text
              name="email"
              text="Email"
              placeholder="example@example.com"
              type="email"
              required
            />
          </Form>
        </Modal.Section>
      </React.Fragment>
    );
  }
}

PasswordResetForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isFetching: isActionInProgress(state, SEND_PASSWORD_RESET_EMAIL),
    errors: state.endpointErrors[SEND_PASSWORD_RESET_EMAIL],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sendPasswordResetEmail: actions.sendPasswordResetEmail,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetForm);



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthModal/PasswordResetForm.js